
import {defineComponent} from 'vue'
export default defineComponent({
    emits: ['pageRefresh'],
    props: {
        isActive: {
            type: Boolean,
            default: false
        }
    },
    setup(_,context){
       let clickRefresh = () => {
        console.log(_)
        context.emit('pageRefresh')
       }
    return {
        clickRefresh
    }

    }
})
